if (!customElements.get('gift-wrap-addon')) {
  customElements.define(
    'gift-wrap-addon',
    class GiftWrapAddon extends HTMLElement {
      constructor() {
        super();
        
        // close other details elements on toggle event
        this.addEventListener('toggle', (event) => {
          const targetDetails = event.target;

          if (targetDetails.tagName === 'DETAILS' && targetDetails.open) {
            // Close all other details elements
            document.querySelectorAll('details[open]').forEach((openDetails) => {
              if (openDetails !== targetDetails) {
                openDetails.open = false;
              }
            });
          }
        }, true);

        // Bind event listeners
        this.setupEventListeners();
      }

      setupEventListeners() {
        // Add click listeners to gift wrap options
        this.addEventListener('click', (event) => {
          const giftWrapOption = event.target.closest('.gift-wrap-option');
          if (giftWrapOption) {
            this.selectGiftWrap(giftWrapOption);
          }

          const addButton = event.target.closest('#AddGiftWrapBtn');
          if (addButton) {
            this.addGiftWrapToCart();
          }
        });
      }

      selectGiftWrap(element) {
        // Remove selected class from all options
        this.querySelectorAll('.gift-wrap-option').forEach(opt => {
          opt.classList.remove('selected');
        });
        
        // Add selected class to clicked option
        element.classList.add('selected');
        
        // Check the radio input
        const radio = element.querySelector('input[type="radio"]');
        radio.checked = true;
        
        // Enable the add button
        const addBtn = this.querySelector('#AddGiftWrapBtn');
        if (addBtn) {
          addBtn.disabled = false;
        }
      }

      addGiftWrapToCart() {
        const selectedOption = this.querySelector('.gift-wrap-option.selected');
        if (!selectedOption) return;
        
        const variantId = selectedOption.dataset.variantId;
        const addBtn = this.querySelector('#AddGiftWrapBtn');
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        
        // Disable button and show loading state
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
        
        // Add to cart like product-form.js
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        
        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              console.error('Error adding gift wrap:', response.description || response.message);
              addBtn.disabled = false;
              addBtn.textContent = 'Add Selected Gift Wrap';
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // Publish cart update event and render contents
            if (window.publish && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'gift-wrap-addon',
                productVariantId: variantId,
                cartData: response,
              });
            }

            // Update cart drawer contents
            cart.renderContents(response);

            // Track successful gift wrap addition in GA4
            if (typeof gtag !== 'undefined') {
              gtag('event', 'gift_wrap_added_to_cart', {
                event_category: 'cart',
                event_label: variantId,
                value: response.items?.find((item) => item.variant_id == variantId)?.price || 0,
                custom_parameters: {
                  gift_wrap_variant_id: variantId,
                  cart_total_items: response.item_count || 0,
                },
              });
            }
          })
          .catch((error) => {
            console.error('Error adding gift wrap:', error);
            addBtn.disabled = false;
            addBtn.textContent = 'Add Selected Gift Wrap';
          })
          .finally(() => {
            // Re-enable button after a short delay to prevent double-clicks
            setTimeout(() => {
              addBtn.disabled = false;
              addBtn.textContent = 'Add Selected Gift Wrap';
            }, 500);
          });
      }
    }
  );
}
